import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../core/auth-service.component';
import { Router } from '@angular/router';
import { UserService, RoutesDto } from '../commonservices/user.service';
import { CookieService } from 'ngx-cookie';
import { switchMap } from 'rxjs/operators';
import { EMPTY, from } from 'rxjs';
import * as _ from 'lodash';
import { EnvService } from '../core/env.service';
import { UserManager, User } from 'oidc-client';
import { CustomCookieService } from '../commonservices/custom-cookie.service';

@Component({
  selector: 'app-signin-callback',
  template: `<div></div>`
  
})

export class SigninRedirectCallbackComponent implements OnInit, AfterViewInit {

  sidebarnavItems: Array<any> = [];
  redirectUrl: any;

  constructor(private _authService: AuthService,
              private _router: Router,
              private _userService: UserService,
              private _cookieService: CookieService,
              private _env: EnvService,
              private _customCookieService :CustomCookieService) { }



  ngOnInit() {
    this._authService.completeLogin().then(user => {
      this._userService.getPageAccess().toPromise().then(pageAccess =>{
        var pages =  pageAccess.Apps;
        this._cookieService.put("pages", JSON.stringify(pages));

        const defaultRoutes = [
          { name: "ctdashboard", url: "/dashboard" },
          { name: "webresolutionv2", url: "/webresolution/webresolutionlist" },
          { name: "ratesearch", url: "/ctms/ratesearch" },
          { name: "raterequestv2", url: "/ctms/raterequest" },
          { name: "edatav2", url: "/eDataNew" },
          { name: "webstorev2", url: "newwebstore" },
          { name: "ctms", url: "/ctms/orders" },
          { name: "imagearchivev2", url: "/newimagearchive" },
          { name: "rules", url: "/rules/coding" }
        ];

        if(pageAccess.RedirectNewTool)
        {
            const defaultApp = defaultRoutes.find(item => item.name === pageAccess.DefaultApp);
            
            if(defaultApp!=null)
            {
              this._cookieService.put("defaultRoute",defaultApp.url);
              this._router.navigate([defaultApp.url], { replaceUrl: true });
            }else
            {
              this._authService.logout(); // it has RedirectNewTool but no new apps so we log out
            }
        }
        else
        {
          //if it is not RedirectNewTool but with new apps get the default app and store to cookie
          const defaultApp = defaultRoutes.find(item => item.name === pageAccess.DefaultApp);
          if(defaultApp!=null)
          {
            this._cookieService.put("defaultRoute",defaultApp.url);
          }
          window.location.href =  this._env.rateTrakApplicationPage;
        }

         var ctgfLoginToken = this._cookieService.get('__CTGFLoginGuid');
        if(ctgfLoginToken == null){
          this._customCookieService.removeAllCookiesExceptOidc();
          this._authService.logout();
          return;
        }
      })
    });
   }

  ngAfterViewInit(): void{

  }
}